import styled from "styled-components"
import media from "styled-media-query"
import { Link } from "gatsby"

export const PostItemLink = styled(Link)`
  color: inherit;
  display: flex;
  text-decoration: none;
  width: 100%;

  ${media.greaterThan("large")`
    /*width: 1006%;*/
    /* width: ${props => (props.fullwidth ? "100%" : "65%")}; */
    /* padding-right: ${props => (props.fullwidth ? "0" : "3em")};; */
  `}

  &:hover {
    opacity: 0.9;
  }
`

export const PostItemWrapper = styled.section`
  align-items: center;
  /* border-bottom: 1px solid #38444d; */
  display: flex;
  padding: 2rem 0;
`

export const PostItemInfo = styled.div`
  display: flex;
  flex-direction: column;
  /* margin-left: 1.5rem; */
`

export const PostItemDate = styled.time`
  font-size: 0.9rem;
  margin: 0.1rem 0;
`
export const PostItemCategory = styled.span`
  align-self: flex-start;
  background: ${props => (props.background ? props.background : "#1fa1f2")};
  border-radius: 0.9em;
  color: ${props => props.theme.colors.powderWhite};
  font-size: ${props => props.theme.fontSizes.small};
  font-weight: 700;
  height: auto;
  padding: 0.25em 0.5em;
`

export const PostItemTitle = styled.h2`
  font-size: ${props => props.theme.fontSizes.h3};
  font-weight: 400;
  margin: 0.5rem 0;
  text-align: left;
`

export const PostItemDescription = styled.p`
  /* font-size: 1rem; */
  /* line-height: 1.75em; */
  margin: 0.75em 0 0;
  font-style: italic;
`
